<script>
// Copilot Loader Component
</script>

<template>
  <div class="flex justify-start">
    <div
      class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-n-weak bg-n-alpha-1"
    >
      <span class="text-xs font-medium text-n-violet-11">
        {{ $t('CAPTAIN.COPILOT.LOADER') }}
      </span>
      <div class="flex space-x-1">
        <div
          class="size-1.5 rounded-full bg-n-violet-9 animate-bounce [animation-delay:-0.3s]"
        />
        <div
          class="size-1.5 rounded-full bg-n-violet-9 animate-bounce [animation-delay:-0.15s]"
        />
        <div class="size-1.5 rounded-full bg-n-violet-9 animate-bounce" />
      </div>
    </div>
  </div>
</template>
